module.exports = __webpack_public_path__ + "static/media/po-lub-4.a1270925.png";